import { Create, useNotify, useRefresh } from 'react-admin';
import PropTypes from 'prop-types';

const CustomCreate = ({ handleClose, redirect, mutationOptions, ...props }) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const resolvedRedirect = redirect ?? (handleClose ? false : 'list');

    const createProps = { redirect: resolvedRedirect, ...props };

    if (handleClose) {
        const { onSuccess, ...otherMutationOptions } = mutationOptions ?? {};
        createProps.mutationOptions = {
            ...otherMutationOptions,
            onSuccess: (data, variables, context) => {
                if (onSuccess) {
                    return onSuccess(data, variables, context);
                }
                notify('ra.notification.created', {
                    type: 'info',
                    messageArgs: { smart_count: 1 },
                });
                refresh();
                handleClose();
            },
        };
    } else if (mutationOptions) {
        createProps.mutationOptions = mutationOptions;
    }

    return <Create {...createProps} />;
};

CustomCreate.propTypes = {
    handleClose: PropTypes.func,
    redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
    mutationOptions: PropTypes.object,
};

export default CustomCreate;
